/**
 * Adresse de retour interne acceptée après une inscription ou une connexion.
 * Un seul « / » en tête (pas de « // » ni de « /\ », que les navigateurs
 * traitent comme une adresse externe), aucun espace ni caractère de contrôle.
 * Seule règle du projet : inscription, connexion, Google et stockage du lien
 * magique l'utilisent tous.
 */
const SAFE_NEXT = /^\/(?![/\\])[^\s\\]*$/;

export function safeNextPath(next: string | null | undefined): string | null {
  return typeof next === "string" && SAFE_NEXT.test(next) ? next : null;
}
